import { Helmet } from 'react-helmet-async';
import ScorecardTimeline from './ScorecardTimeline';

export default function DeveloperScorecard() {
  return (
    <>
      <Helmet>
        <title>Developer Scorecard</title>
      </Helmet>
      <ScorecardTimeline />
    </>
  );
}
